import { render, staticRenderFns } from "./BolWorkStats.vue?vue&type=template&id=0d6bbff0&"
import script from "./BolWorkStats.vue?vue&type=script&lang=js&"
export * from "./BolWorkStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports